// extracted by mini-css-extract-plugin
export default {"Container":"Depositions_Container__98g5A","Box":"Depositions_Box__BGOzH"};